import React from 'react';
import { ApolloProvider, ApolloConsumer } from '@apollo/react-hooks';
import TastingKitSnackBarComponent from './TastingKitSnackBarComponent';
import { client } from '../../../../../monorepo/apollo/client';

export interface TastingKitPromoProps {
  user: any;
  config: {
    promotionTextOne?: string;
    promotionTextTwo?: string;
    promoOneColor?: string;
    promoTwoColor?: string;
    linkOne?: string;
    linkTwo?: string;
    textOneColor?: string;
    textTwoColor?: string;
    flashSaleEndDate?: string;
  };
}

const TastingKitSnackBar = ({ user, config }: TastingKitPromoProps) => {
  return (
    <>
      <ApolloProvider client={client}>
        <ApolloConsumer>
          {apolloClient => (
            <TastingKitSnackBarComponent
              user={user}
              apolloClient={apolloClient}
              config={config}
            />
          )}
        </ApolloConsumer>
      </ApolloProvider>
    </>
  );
};

export default TastingKitSnackBar;
